import React from 'react'

const Messages = () => {
  return (
    <svg
      fill='none'
      viewBox='0 0 26 24'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M13 1C6.649 1 1.5 5.253 1.5 10.5a8.739 8.739 0 003.4 6.741L2.5 23l6.372-3.641c1.335.425 2.727.641 4.128.641 6.351 0 11.5-4.253 11.5-9.5S19.351 1 13 1z'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
      />
    </svg>
  )
}

export default Messages
